import { render, staticRenderFns } from "./EmpresaLayout.vue?vue&type=template&id=241a8b56&scoped=true&"
import script from "./EmpresaLayout.vue?vue&type=script&lang=js&"
export * from "./EmpresaLayout.vue?vue&type=script&lang=js&"
import style0 from "./EmpresaLayout.vue?vue&type=style&index=0&id=241a8b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241a8b56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VApp,VMain,VOverlay,VProgressCircular})
